import React, { useContext, useState } from 'react';
import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import logo from '../../assets/images/logo/Garudanew.png';
import CustomizerContext from '../../_helper/Customizer';

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, toggleIcon, layout, layoutURL } = useContext(CustomizerContext);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
   <div className="logo-wrapper  bg-[#fffff] h-[80px] w-[265px] flex items-center justify-center">
  <Link to={`/dashboard`}>
    <Image attrImage={{ className: 'img-fluid d-inline', src: `${logo}`, alt: '' }} />
  </Link>
</div>

  );
};

export default SidebarLogo;
